var React = require('react');

function InlineSvg (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M10 0C15.5228 0 20 4.47715 20 10C20 14.3157 17.2659 17.9923 13.4355 19.3936C13.4312 19.3957 13.4272 19.3983 13.4229 19.4004C12.5044 19.8504 11.7438 20.5686 11.2422 21.46C11.1667 21.594 11.0974 21.7372 10.959 22.0225L10 24L9.04102 22.0225C8.90262 21.7372 8.83326 21.594 8.75781 21.46C8.25625 20.5686 7.49561 19.8504 6.57715 19.4004C6.57258 19.3982 6.56807 19.3958 6.56348 19.3936C2.73355 17.992 0 14.3154 0 10C0 4.47715 4.47715 5.15422e-07 10 0ZM10 6C7.79086 6 6 7.79086 6 10C6.00013 12.209 7.79094 14 10 14C12.2091 14 13.9999 12.209 14 10C14 7.79086 12.2091 6 10 6Z","fill":"#C7C7D1"}));
}

InlineSvg.defaultProps = {"width":"20","height":"24","viewBox":"0 0 20 24","fill":"none"};

module.exports = InlineSvg;

InlineSvg.default = InlineSvg;
